// Extracted from https://vanillajstoolkit.com/helpers/scrollstop/
exports.onScrollStop = (el, callback) => {
  let isScrolling;

  el.addEventListener('scroll', event => {
    window.clearTimeout(isScrolling);
    isScrolling = setTimeout(() => callback(event), 50);
  });
};

exports.autoClearableSetInterval = (validateFn, limit, intervalMs, { onFullfillment, onLimit }) => {
  let intervalId = setInterval(() => {
    if(limit-- > 0){
      if(validateFn()){
        clearTimeout(intervalId);
        onFullfillment();
      }
    }else{
      clearTimeout(intervalId)
      onLimit();
    }
  }, intervalMs)
}
